module.exports = __webpack_public_path__ + "img/Handshake.f9e5b9b5.png";